/* eslint-disable */
/* THIS FILE HAS BEEN GENERATED DO NOT EDIT IT DIRECTLY */
import * as Types from '../../../../../graphql/__generated__/types';

import { gql } from '@apollo/client';
import * as ApolloReactCommon from '@apollo/client';
import * as ApolloReactHooks from '@apollo/client';
const defaultOptions = {} as const;
export type ConfigBurnInRefreshTime_ConfigFragment = { __typename: 'ConfigurationModel', id: string, burnInRefresh?: { __typename: 'ConfigBurnInRefreshState', reported: { __typename: 'ConfigBurnInRefresh', time: string } } | null };

export type UpdateConfigBurnInRefreshTimeMutationVariables = Types.Exact<{
  input: Types.ConfigurationUpdateBurnInRefreshInput;
}>;


export type UpdateConfigBurnInRefreshTimeMutation = { __typename: 'Mutation', configurationUpdateBurnInRefresh: { __typename: 'ConfigurationModel', id: string } };

export const ConfigBurnInRefreshTime_ConfigFragmentDoc = gql`
    fragment ConfigBurnInRefreshTime_config on ConfigurationModel {
  id
  burnInRefresh {
    reported {
      time
    }
  }
}
    `;
export const UpdateConfigBurnInRefreshTimeDocument = gql`
    mutation updateConfigBurnInRefreshTime($input: ConfigurationUpdateBurnInRefreshInput!) {
  configurationUpdateBurnInRefresh(input: $input) {
    id
  }
}
    `;
export type UpdateConfigBurnInRefreshTimeMutationFn = ApolloReactCommon.MutationFunction<UpdateConfigBurnInRefreshTimeMutation, UpdateConfigBurnInRefreshTimeMutationVariables>;

/**
 * __useUpdateConfigBurnInRefreshTimeMutation__
 *
 * To run a mutation, you first call `useUpdateConfigBurnInRefreshTimeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateConfigBurnInRefreshTimeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateConfigBurnInRefreshTimeMutation, { data, loading, error }] = useUpdateConfigBurnInRefreshTimeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateConfigBurnInRefreshTimeMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateConfigBurnInRefreshTimeMutation, UpdateConfigBurnInRefreshTimeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateConfigBurnInRefreshTimeMutation, UpdateConfigBurnInRefreshTimeMutationVariables>(UpdateConfigBurnInRefreshTimeDocument, options);
      }
export type UpdateConfigBurnInRefreshTimeMutationHookResult = ReturnType<typeof useUpdateConfigBurnInRefreshTimeMutation>;
export type UpdateConfigBurnInRefreshTimeMutationResult = ApolloReactCommon.MutationResult<UpdateConfigBurnInRefreshTimeMutation>;
export type UpdateConfigBurnInRefreshTimeMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateConfigBurnInRefreshTimeMutation, UpdateConfigBurnInRefreshTimeMutationVariables>;